import { ReactElement } from "react";
import { FormContextValues } from "react-hook-form";
import { EquityTradeInputs } from "$gql/types.gen";
import MarketBuy from "./MarketBuy";
import LimitBuy from "./LimitBuy";
import StopLossBuy from "./StopLossBuy";
import StopLimitBuy from "./StopLimitBuy";

export interface ComponentProps<T> {
  order: T | null;
  form: FormContextValues<T>;
}

export type TradeTypeFields<T> = {
  form: FormContextValues<T>;
};

export type TradeInputsWithoutSymbol = Omit<EquityTradeInputs, "symbol">;

export type TradeType<T> = {
  BuildOrder(data: T): TradeInputsWithoutSymbol;
  Component(props: ComponentProps<T>): ReactElement;
};

export type ExtraTradeFields = {
  clientOrderId: string;
  previewId?: string;
};

export type OrderType = "market" | "limit" | "stop" | "stop_limit";
export type DurationType = "day" | "gtc";

export const TradeOptions: {
  label: string;
  value: OrderType;
}[] = [
  { label: "Market Order", value: "market" },
  { label: "Limit Order", value: "limit" },
  { label: "Stop Loss Order", value: "stop" },
  { label: "Stop Limit Order", value: "stop_limit" },
];

export const DurationOptions: {
  label: string;
  value: DurationType;
}[] = [
  { label: "Good for Day", value: "day" },
  { label: "Good till Cancelled", value: "gtc" },
];

export function GetBundleForOrderType(
  orderType: OrderType
): TradeType<Partial<EquityTradeInputs>> {
  switch (orderType) {
    case "market":
      return MarketBuy as TradeType<Partial<EquityTradeInputs>>;

    case "limit":
      return LimitBuy as TradeType<Partial<EquityTradeInputs>>;

    case "stop":
      return StopLossBuy as TradeType<Partial<EquityTradeInputs>>;

    case "stop_limit":
      return StopLimitBuy as TradeType<Partial<EquityTradeInputs>>;
  }
}
